import { parseNumber } from 'libphonenumber-js';

const required = value => (value ? undefined : 'Required');

const email = value => (
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined
);

const phone = value => (
  value && !parseNumber(value, 'US').phone
    ? 'Invalid phone number'
    : undefined
);

const maxLength = length => value => (
  value && value.length > length
    ? 'Ensure this field has no more than 10 characters.'
    : undefined
);

export {
  email,
  phone,
  required,
  maxLength,
};



// WEBPACK FOOTER //
// ./src/utils/validators.js